import React from 'react';
import { graphql } from 'gatsby';
import AudienceNavigation from './AudienceNavigation';
const ModularIconHeaderPath = ({ data }) => {
  const { iconHeadingPathContent, backgroundColor } = data;
  return (
    <div className={`${backgroundColor}`}>
      <div className="modular-icon-header-path-container">
        {iconHeadingPathContent.map(({ heading, image, path }, index) => {
          return (
            <AudienceNavigation
              heading={heading}
              image={image}
              path={path}
              index={index}
            />
          );
        })}
      </div>
    </div>
  );
};
export default ModularIconHeaderPath;
export const fragment = graphql`
  fragment ModularIconHeaderPath on DatoCmsIconHeaderPath {
    internal {
      type
    }
    backgroundColor
    iconHeadingPathContent {
      heading {
        value
      }
      image {
        gatsbyImageData
      }
      path
    }
  }
`;
